import { Typography, Box } from '@mui/material';
import { QuadrantChartWidget } from '../components/widgets/QuadrantChartWidget';

export default function Dashboard() {
  return (
    <>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Portfolio 4-Quadrant Analysis - View stocks across strategic quadrants based on news sentiment and institutional money flow
        </Typography>
      </Box>

      {/* Quadrant Chart Widget */}
      <Box sx={{ mb: 3 }}>
        <QuadrantChartWidget />
      </Box>

      {/* Explanation Section */}
      <Box sx={{ mt: 4, p: { xs: 2, sm: 3 }, backgroundColor: 'rgba(255, 255, 255, 0.02)', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom>
          Understanding the 4-Quadrant Strategy
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          This chart plots each stock based on two independent signals:
        </Typography>
        <Box component="ul" sx={{ pl: 2, '& li': { mb: 1 } }}>
          <li>
            <Typography variant="body2">
              <strong>X-axis (News Sentiment):</strong> AI analysis of recent news headlines using Dual AI (GPT-OSS + DistilBERT)
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Y-axis (Money Flow):</strong> Institutional money flow using Chaikin Money Flow (CMF) indicator
            </Typography>
          </li>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          By combining these two dimensions, we can identify hidden opportunities (Quadrant II) and avoid bull traps (Quadrant IV)
          that single-signal strategies might miss.
        </Typography>
      </Box>
    </>
  );
}
